import React from 'react';
import Form from 'react-bootstrap/Form';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import { useIntl } from 'react-intl';

const SwitchCheckbox = props => {

    const { inputData: { checked, id, valueToPass, disabled, tooltipText, ariaLabel } = {}, label: { text, labelClass } = {} } = props;
    const intlApi = useIntl();
    const isLabelText = typeof text === 'string' ? true : false;
    const tooltipId = `${id}_tooltip`;
    const tooltipContent = disabled && tooltipText ? intlApi.formatMessage({ id: tooltipText }) : null;

    const handleChange = () => {
        props.inputActions.handleFieldChange(!checked, valueToPass);
    };

    return (
        <>
            <Form.Check
                data-tooltip-id={tooltipId}
                data-tooltip-content={tooltipContent}
                type="switch"
                id={id}
                label={<span className={`instruction_link ${labelClass && labelClass.join(' ')}`}>{text}</span>}
                checked={checked}
                style={{ paddingLeft: '48px' }}
                onChange={handleChange}
                disabled={disabled}
                {...(ariaLabel
                    ? { 'aria-label': ariaLabel }
                    : isLabelText
                        ? { 'aria-label': `${text} checkbox` }
                        : {})}
            />
            <ReactTooltip id={tooltipId} place="top" className="tooltip-component" />
        </>
    );
};

export default SwitchCheckbox;
